import React from 'react';
import { useTranslation } from 'react-i18next';
import { BehaviourEntryItem } from '@/components/DiaryTable/BehaviourEntryItem';
import { NOTES_COLUMNS } from '@/components/DiaryTable/columns';
import { TeacherMessageItem } from '@/components/DiaryTable/TeacherMessageItem';
import type { DiaryBehaviourEntry, DiaryNote } from '@/types/diary';

interface Props {
  behaviourEntries: DiaryBehaviourEntry[];
  notes: DiaryNote[];
}

export const DiaryNotesRow: React.FC<Props> = ({ behaviourEntries, notes }) => {
  const { t } = useTranslation();

  return (
    <div className={`grid ${NOTES_COLUMNS} border-t border-border-table`}>
      <div className="border-r border-border-table" />

      <div className="text-subhead-14 flex items-center border-r border-border-table py-2 pr-3 pl-5 text-foreground">
        {t('home.dashboard.diary.title')}
      </div>

      <div className="flex flex-col divide-y divide-border-table">
        {notes.map((note, index) => (
          <TeacherMessageItem key={index} note={note} />
        ))}
        {behaviourEntries.map((entry, index) => (
          <BehaviourEntryItem key={index} entry={entry} />
        ))}
      </div>
    </div>
  );
};
